import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AutomationContext,
  IAutomationRuleGroup,
} from '@kinet-open-network/shared/data-access/model';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { distinctUntilChanged, startWith } from 'rxjs';
import { AutomationConditionRuleGroupComponent } from './automation-condition-rule-group.component';
import { AutomationConditionService } from './automation-condition.service';
interface AutomationConditionBuilderProps extends FormlyFieldProps {
  context?: AutomationContext;
}

export interface FormlyPriceConditionsFieldConfig
  extends FormlyFieldConfig<AutomationConditionBuilderProps> {}

@Component({
  selector: 'kon-automation-condition-builder-type',
  imports: [AutomationConditionRuleGroupComponent],
  providers: [AutomationConditionService],
  template: `
    <kon-automation-condition-rule-group
      [group]="group()"
      (groupChange)="handleGroupChange($event)"
      [canDelete]="false"
      [context]="props.context"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutomationConditionBuilderTypeComponent
  extends FieldType<FieldTypeConfig<AutomationConditionBuilderProps>>
  implements OnInit
{
  readonly #conditionService = inject(AutomationConditionService);
  readonly #destroyRef = inject(DestroyRef);

  readonly group = signal<IAutomationRuleGroup>(
    this.#conditionService.createRuleGroup(),
  );

  ngOnInit() {
    this.formControl.valueChanges
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        startWith(this.formControl.value),
        distinctUntilChanged(),
      )
      .subscribe((value) => {
        if (!value) {
          this.group.set(this.#conditionService.createRuleGroup());
        } else {
          this.group.set(value as IAutomationRuleGroup);
        }
      });
  }

  handleGroupChange(group: IAutomationRuleGroup) {
    this.formControl.setValue({
      ...group,
    });
  }
}
